import { FC } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes.ts';
import Middleware from '@/router/middleware/index.tsx';

const IsTrialOrNotActiveSubscription: FC = () => {
  const { isLoading, isTrial, isSubscriptionActive } = useAuthContext();

  return (
    <Middleware isLoading={isLoading}>
      {isTrial || !isSubscriptionActive ? <Outlet /> : <Navigate to={Routes.DASHBOARD} />}
    </Middleware>
  );
};

export default IsTrialOrNotActiveSubscription;
